import type {BilingualStringList} from '../../../../../types/shared-types';

export const mapBilingualStringList = (raw: unknown): BilingualStringList => {
  if (!raw || typeof raw !== 'object') {
    return {en: [], de: []};
  }

  const list = raw as Record<string, unknown>;

  return {
    en: Array.isArray(list.en) ? (list.en as string[]) : [],
    de: Array.isArray(list.de) ? (list.de as string[]) : [],
  };
};
